import React from "react";
import { useTranslation } from "react-i18next";
import downloadIcon from "../../assets/icon-download.svg";

import "../widgets.css";
import "./app-installation.css";
import { AppStoreLinks } from "../app-store-links/app-store-links";

export function AppInstallationWidget(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="app-installation-widget widget-card">
      <img className="icon-download" src={downloadIcon} alt="download-icon" />

      <div className="app-installation-widget-info">
        <span className="app-installation-title widget-title">
          {t("widgets.downloadTitle")}
        </span>
        <span className="app-installation-description widget-description">
          {t("widgets.downloadDescription")}
        </span>
        <AppStoreLinks />
      </div>
    </div>
  );
}
